import PageNotFoundIllustration from '../images/generatingPreview.png';

export const handleThumbnailError = e => {
  e.target.src = PageNotFoundIllustration;
};

export const INSERT_NAMESPACES = ['INSERTS_TAB'];
